import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TargetedAdService, TARGETED_AD_CONFIGURATION, TargetedAdConfiguration, AdDefinition } from './targeted-ad.service';
import { TargetedAdComponent } from './targeted-ad.component';

@NgModule({
  imports: [CommonModule],
  declarations: [TargetedAdComponent],
  exports: [TargetedAdComponent]
})

export class TargetedAdModule {
}

export {
  TargetedAdComponent,
  TargetedAdService,
  TARGETED_AD_CONFIGURATION,
  TargetedAdConfiguration,
  AdDefinition
};
